module.exports = __webpack_public_path__ + "static/leger-b428712be192c4f542d5bb50c7c92972.jpg";